import 'twin.macro';
import 'styled-components/macro';
import { FC } from 'react';

import { Icon } from '../../index';

export const LoadingPlaceholder: FC<{ height: number }> = ({ height }) => (
  <div tw="flex justify-center items-center w-full bg-gray-5 rounded-sm" style={{ height }}>
    <div>
      <Icon
        aria-label="loading"
        name="circle-loader"
        tw="text-4xl animate-spin transition-all duration-fast leading-normal"
      />
    </div>
  </div>
);
